import { Controller } from "@hotwired/stimulus"

// Tab switcher shared by community tabs and the interests/hobbies tabs.
//
// Markup (both button and pane carry data-tab="<name>"):
//   <div data-controller="tabs" data-tabs-default-value="about">
//     <button data-tabs-target="tab"  data-tab="about" data-action="tabs#switch">About</button>
//     <div    data-tabs-target="pane" data-tab="about">…</div>
//   </div>
//
// Panes are shown/hidden by toggling the "active" class AND inline display, so
// it works whether or not the page's CSS hides inactive panes (the interests
// tabs rely on inline display; community panes use the .active class).
export default class extends Controller {
  static targets = ["tab", "pane"]
  static values = { default: String }

  connect() {
    const initial =
      this.defaultValue ||
      this.tabTargets.find((t) => t.classList.contains("active"))?.dataset.tab ||
      this.tabTargets[0]?.dataset.tab
    if (initial) this.showTab(initial)
  }

  switch(event) {
    event.preventDefault()
    this.showTab(event.currentTarget.dataset.tab)
  }

  showTab(tabName) {
    this.tabTargets.forEach((tab) => {
      const on = tab.dataset.tab === tabName
      tab.classList.toggle("active", on)
      if (tab.style.borderBottomColor !== "") tab.style.borderBottomColor = on ? "#ef4444" : "transparent"
    })
    this.paneTargets.forEach((pane) => {
      const on = pane.dataset.tab === tabName
      pane.classList.toggle("active", on)
      pane.style.display = on ? "" : "none"
    })
  }
}
